import {
  NgModule
} from '@angular/core';
import {
  ButtonsModule
} from '@progress/kendo-angular-buttons';
import {
  GridModule
} from '@progress/kendo-angular-grid';
import {
  DateInputsModule
} from '@progress/kendo-angular-dateinputs';
import {
  DropDownsModule
} from '@progress/kendo-angular-dropdowns';
import {
  InputsModule
} from '@progress/kendo-angular-inputs';
import {
  SharedCommonModule
} from '../../../../shared/common';
import {
  LoadingIndicatorModule
} from '../../../../shared/layout/components/loading-indicator/loading-indicator.module';
import {BreadcrumbModule} from '../../../../shared/layout/components/breadcrumb/breadcrumb.module';
import {UsersComponent} from './users.component';
import {ConfirmDialogComponent} from '../../../../shared/layout/components/confirm-dialog/confirm-dialog.component';
import {UserDialogComponent} from './user-dialog.component';
import {UsersService} from './users.service';
import {AgmJsMarkerClustererModule} from '@agm/js-marker-clusterer';
import {AgmCoreModule} from '@agm/core';
import {FlexLayoutModule} from '@angular/flex-layout';
import {MatExpansionModule} from '@angular/material/expansion';
import {FloatingLabelModule} from '@progress/kendo-angular-label';

@NgModule({
  declarations: [
    UsersComponent,
    UserDialogComponent
  ],
  imports: [
    ButtonsModule,
    GridModule,
    DateInputsModule,
    DropDownsModule,
    FloatingLabelModule,
    InputsModule,
    LoadingIndicatorModule,
    MatExpansionModule,
    BreadcrumbModule,
    SharedCommonModule,
    AgmCoreModule,
    AgmJsMarkerClustererModule,
    FlexLayoutModule
  ],
  providers: [
    UsersService
  ],
  entryComponents: [
    ConfirmDialogComponent,
    UserDialogComponent
  ],
})
export class UsersModule {
}
